import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { LoginController, DropDownController } from '@/services/request.service';
import { DropDownResponse } from '@/services/__model';
import { fileUploader } from '@/services/qiniu.service.new';
import Form from '@/components/mixins/Form';
import moment, { Moment } from 'moment';
import utils from './utils';
import {
  debounce
} from '@/utils/utils';
@Component
export default class FormStep1 extends Mixins(Form) {
  @Prop() public userInfo!: any;
  @Prop() public draftInfo!: any;
  @Prop() public enquiryData!: any;

  @Prop() public step2Info!: any;
  @Prop() public gradeList!: Array<DropDownResponse>;
  @Prop() public currentYear!: string;
  @Prop() public displayYear!: string;

  @Prop() public sectionDateList!: any;
  public applicationStep1Form: any;
  public searchText: any = '';
  public changeDebounce = debounce(this.getAutoList);
  public age: number = 0;
  public siblingInfoList: any = [];
  public location: any = [];
  public censusLocation: any = [];
  public isHasSibling: string = '';
  public isHasDefaultSibling: boolean = false;
  public moment = moment;
  public isAgeInvalid: boolean = false;
  public isBoarding: boolean = true;
  public isStudentExist: boolean = false;
  public isUpoadingIDList: boolean = false;
  public isUpoadingPhoto: boolean = false;
  public photoList: Array<any> = [];
  public IDList: Array<any> = [];
  public sourceIsOther: boolean = false;
  public sourceId: number = 54;
  public campusType: number = -1;
  public isSource: boolean = false;
  public studentSource: boolean = false;
  public teacherSource: boolean = false;
  public value: any = ''
  public dataSource: any = []
  public utils = utils;
  public sourceExtra: any = '';
  public sourceExtraId: any = '';
  public get fieldNames() {
    return { label: this.locale === 'zh' ? 'value' : 'enValue', value: 'key', children: 'children' };
  }

  public beforeCreate(): void {
    this.applicationStep1Form = this.$form.createForm(this);
  }

  public get locale(): string {
    return this.$i18n.locale;
  }
  public handleSourceChange(value: number): void {
    this.sourceId = value;
    this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(value) ? true : false;
    this.teacherSource = value === 1280 ? true : false
    this.studentSource = value === 741 ? true : false
  }
  public getAutoList() {
    if (this.studentSource === true) {
      DropDownController.getStudentsByName(this.searchText).then(res => {
        if (res) {
          this.dataSource = [];
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push({
                // vaule: item.value + item.enValue,
                // key: item.key,
                value: item.value + item.enValue,
                key: item.key,
              });
            } else {
              this.dataSource.push({ value: item.value, key: item.key });
            }
          });
        }
      });
    }
    if (this.teacherSource === true) {
      DropDownController.getMembersByName(this.searchText).then(res => {
        //   this.data = res && res.data ? res.data : {};
        // for (var i in this.data) {
        //   this.studentList.push(this.data[i].name);
        // }
        if (res) {
          this.dataSource = [];
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push({
                // vaule: item.value + item.enValue,
                // key: item.key,
                value: item.value + item.enValue,
                key: item.key,
              });
            } else {
              this.dataSource.push({ value: item.value, key: item.key });
            }
          });
        }
        // this.dataSource = res.data
      });
    }
  }
  public onSelect() {

  }
  public ontabChange() { }

  public onSourceSelect(value: any, option: any) {
    this.sourceExtraId = Number(value);
    this.dataSource.map((item: any) => {
      if (item.key === this.sourceExtraId) {
        this.sourceExtra = item.value;
      }
    });
    this.$nextTick(() => {
      this.applicationStep1Form.setFieldsValue({
        sourceExtra: this.sourceExtra,
      });
    });
  }
  public onSearch(searchText: any) {
    if (searchText) {
      this.searchText = searchText.trim();
      this.changeDebounce();
    }
    // if (this.teacherSource === true) {
    //   DropDownController.getMembersByName(searchText).then(res => {
    //     //   this.data = res && res.data ? res.data : {};
    //     // for (var i in this.data) {
    //     //   this.studentList.push(this.data[i].name);
    //     // }
    //     if (res) {
    //       this.dataSource = []
    //       res.data.map(item => {
    //         if (item.enValue) {
    //           this.dataSource.push(item.value + item.enValue)
    //         } else {
    //           this.dataSource.push(item.value)
    //         }
    //       })
    //     }
    //     // this.dataSource = res.data
    //   })
    // }
    // if (this.studentSource === true) {
    //   DropDownController.getStudentsByName(searchText).then(res => {
    //     if (res) {
    //       this.dataSource = []
    //       res.data.map(item => {
    //         if (item.enValue) {
    //           this.dataSource.push(item.value + item.enValue)
    //         } else {
    //           this.dataSource.push(item.value)
    //         }
    //       })
    //     }
    //   })
    // }
  }
  public onChange(value: any) {

  }
  public created() {
    // this.handleYearChange
  }
  // @Watch('userInfo', { immediate: true })
  // public setFormContent(): void {
  //   console.log(this.userInfo)
  //   const isDraft = this.$route.query.isDraft;
  //   if (!isDraft) {
  //     const siblingInfoList = this.userInfo && this.userInfo.siblings ? this.userInfo.siblings : [];
  //     this.setSiblingList(siblingInfoList);
  //   }
  // }

  public setSiblingList(siblingInfoList: any): void {
    this.isHasSibling = siblingInfoList.length > 0 ? 'true' : 'false';
    let isHasDefaultSibling = false;
    this.siblingInfoList = siblingInfoList.map((item: any) => {
      if (item.siblingStudentId) {
        isHasDefaultSibling = true;
      }
      return {
        ...item,
        disabled: item.siblingStudentId ? true : false,
      };
    });

    this.isHasDefaultSibling = isHasDefaultSibling;
  }

  public setDefaultSiblingList(siblingInfoList: any): void {
    this.isHasSibling = siblingInfoList.length > 0 ? 'true' : '';
    let isHasDefaultSibling = false;
    this.siblingInfoList = siblingInfoList.map((item: any) => {
      if (item.siblingStudentId) {
        isHasDefaultSibling = true;
      }
      return {
        ...item,
        disabled: item.siblingStudentId ? true : false,
      };
    });

    this.isHasDefaultSibling = isHasDefaultSibling;
  }
  public radioChange(e: any): void {
    const idNumber = this.applicationStep1Form.getFieldValue('idNumber');
    this.verifyStudent(e.target.value, idNumber);
  }

  public idNumberChange(e: any): void {
    utils.fixIOSScroll();
    const idType = this.applicationStep1Form.getFieldValue('idType');
    this.verifyStudent(idType, e.target.value);
  }

  public changeLocation(list: any): void {
    this.location = list;
  }

  public changeCensusLocation(list: any): void {
    this.censusLocation = list;
  }

  public verifyStudent(idType: number, idNumber: string): void {
    if (idType && idNumber) {
      LoginController.applicationExist({ idType, idNumber }).then((res: any) => {
        if (res.data && res.data.exist === true) {
          this.$message.error(this.$tc('applicationForm.studentExist'));
          this.isStudentExist = true;
        } else {
          this.isStudentExist = false;
        }
      });
    }
  }

  public checkCountryAndName(values: any): boolean {
    let flag = false;
    if ([1, 86, 114, 190].includes(values.countryId)) {
      if (!values.name || !values.enName) {
        flag = true;
      }
    }
    return flag;
  }

  public setAge(birthday: any): void {
    let age = moment().year() - birthday.year();
    if (birthday.isBefore(birthday.year() + '-09-01')) {
      age += 1;
    }
    this.age = age;
  }

  public handleNationalityChange(value: number, option: any): void {
    this.getRightCampusIdByCountryId(value);
  }

  public handleYearChange(value: number, option: any): void {
    const birthday = this.applicationStep1Form.getFieldValue('birthday');
    if (birthday && value) {
      this.getRightSectionIdByBirthday(birthday, value[0]);

    } else {
      this.isAgeInvalid = false;
      this.campusType = -1;
      this.applicationStep1Form.setFieldsValue({ sectionId: undefined, campusId: undefined });
    }
  }

  public onDateOfBirthChange(date: any, dateString: string) {
    if (date) {
      this.setAge(date);
      const year = this.applicationStep1Form.getFieldValue('schoolYearId');
      if (year) {
        this.getRightSectionIdByBirthday(date, year[0]);
      } else {
        this.isAgeInvalid = false;
        this.campusType = -1;
        this.applicationStep1Form.setFieldsValue({ sectionId: undefined });
      }
    } else {
      this.isAgeInvalid = false;
      this.campusType = -1;
      this.applicationStep1Form.setFieldsValue({ sectionId: undefined, campusId: undefined });
    }
  }

  public getRightSectionIdByBirthday(date: Moment, year: number): void {
    // 选择的申请学年索引值
    let schoolYearIndex = '',
      commendYearIndex = '';
    const schoolYearAndSemesterList = this.$store.state.schoolYearAndSemesterList;
    for (const index in schoolYearAndSemesterList) {
      if (schoolYearAndSemesterList[index].key === year) {
        schoolYearIndex = index;
      }
      if (schoolYearAndSemesterList[index].value === this.currentYear) {
        commendYearIndex = index;


      }
    }
    let newDate = moment(date);
    if (schoolYearIndex < commendYearIndex) {
      let interval = parseInt(commendYearIndex, 10) - parseInt(schoolYearIndex, 10);
      newDate = moment(date).add(interval, 'years');
    } else if (schoolYearIndex > commendYearIndex) {
      let interval = parseInt(schoolYearIndex, 10) - parseInt(commendYearIndex, 10);
      newDate = moment(date).subtract(interval, 'years');

    }
  

    // 获取sectionDateList对应的sectionId索引值
    let sectionIdIndex: string = '';
    for (const index in this.sectionDateList) {
      const item = this.sectionDateList[index];
      if (moment(newDate).isBetween(moment(item.timeStart), moment(item.timeEnd))) {
        sectionIdIndex = index;
      }
    }
    if (sectionIdIndex !== '') {
      // 根据学年索引值和推荐的sectionId索引值计算正确的sectionId和是否可住宿flag
      const rightSectionIndex = Number(sectionIdIndex);
      const rightSectionId = this.sectionDateList[rightSectionIndex].sectionId;
      this.isBoarding = this.sectionDateList[rightSectionIndex].enableBoardingFlag;
      this.isAgeInvalid = false;
      this.campusType = this.sectionDateList[rightSectionIndex].sectionType;
      this.getRightCampusIdByCountryId();
      this.$nextTick(() => {
        this.applicationStep1Form.setFieldsValue({
          sectionId: rightSectionId,
          boarding: !this.isBoarding ? 'false' : undefined,
        });
      });

    } else {
      // 不合法
      this.isAgeInvalid = true;
      this.campusType = -1;
      this.applicationStep1Form.setFieldsValue({ sectionId: undefined, campusId: undefined });
    }
  }

  public getRightCampusIdByCountryId(value?: number): void {
    const countryId = value || this.applicationStep1Form.getFieldValue('countryId');
    if (countryId && this.campusType !== -1) {
      const itemOptions = this.$store.state.campusList.filter((item: any) => item.sectionType === this.campusType);
      if (itemOptions && itemOptions.length > 1) {
        let itemTemp = itemOptions.filter((item: any) => item.campusType === 81)[0];
        if (countryId !== 1 && countryId !== 86 && countryId !== 114 && countryId !== 190) {
          itemTemp = itemOptions.filter((item: any) => item.campusType === 82)[0];
        }
        const schoolId = itemTemp.key;
        this.applicationStep1Form.setFieldsValue({ campusId: schoolId });
      } else if (itemOptions && itemOptions.length === 1) {
        this.applicationStep1Form.setFieldsValue({ campusId: itemOptions[0].key });
      }
    } else {
      this.applicationStep1Form.setFieldsValue({ sectionId: undefined, campusId: undefined });
    }
  }

  public checkFile(file: any, fun: any): void {
    const i = file.name.lastIndexOf('.');
    const suffix = file.name.slice(i).toLowerCase();
    const suffixArray = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf', '.xls', '.xlsx'];
    if (!suffixArray.includes(suffix)) {
      this.$message.error(this.$tc('fileTypeErr'));
    } else if (file.size > 10 * 1024 * 1024) {
      this.$message.error(this.$tc('fileSizeErr'));
    } else {
      fun && fun();
    }
  }

  public beforeUploadOfPhoto(file: any): boolean {
    if (this.photoList.length >= 1) {
      this.$message.error(this.$tc('attachmentTip'));
    } else {
      this.checkFile(file, () => {
        this.isUpoadingPhoto = true;
        this.uploadFile(file, (res: any) => {
          this.isUpoadingPhoto = false;
          if (this.photoList.length < 1) {
            this.photoList.push(res);
          }
        });
      });
    }
    return false;
  }

  public beforeUploadOfIDList(file: any): boolean {
    if (this.IDList.length >= 2) {
      this.$message.error(this.$tc('attachmentTip'));
    } else {
      this.checkFile(file, () => {
        this.isUpoadingIDList = true;
        this.uploadFile(file, (res: any) => {
          this.isUpoadingIDList = false;
          if (this.IDList.length < 2) {
            this.IDList.push(res);
          }
        });
      });
    }
    return false;
  }

  public uploadFile(file: any, fun: any): void {
    const i = file.name.lastIndexOf('.');
    const suffix = file.name.slice(i).toLowerCase();
    const suffixArray = ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf', '.xls', '.xlsx'];
    if (suffixArray.includes(suffix)) {
      fileUploader(file, file.name)
        .then(res => {
          fun && fun(res);
        })
        .catch(() => { });
    } else {
      this.$message.error(this.$tc('fileTypeErr'));
    }
  }

  public deleteFile(index: any): void {
    this.IDList.splice(index, 1);
  }

  public openFile(resourceUrl: string): void {
    window.open(resourceUrl);
  }

  public addSibling(): void {
    this.siblingInfoList = this.siblingInfoList.concat({ id: this.siblingInfoList.length + 1 });
  }

  public changeIsHasSibling(e: any): void {
    this.isHasSibling = e.target.value;
    if (this.isHasSibling === 'false') {
      this.siblingInfoList = [];
    } else {
      this.siblingInfoList = this.siblingInfoList.concat({ id: 1 });
    }
  }

  public changeSiblingInfo(info: any): void {
    const siblingInfoList = this.siblingInfoList.slice();
    let index = -1;
    siblingInfoList.forEach((item: any, i: number) => {
      if (item.id === info.id) {
        index = i;
      }
    });
    siblingInfoList.splice(index, 1);
    siblingInfoList.push(info);
    this.siblingInfoList = siblingInfoList;
  }

  public deleteItem(id: any) {
    let index = -1;
    this.siblingInfoList.forEach((item: any, i: number) => {
      if (item.id === id) {
        index = i;
      }
    });
    if (index !== -1) {
      this.siblingInfoList.splice(index, 1);
    }
    if (this.siblingInfoList.length === 0) {
      this.isHasSibling = '';
    }
  }
}
